import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ButtonCard} from 'shells/card/button-card';

import styles from './recipient-selector-list-item.module.css';

type Props = {
    title: string;
    subtitle?: string | React.ReactElement<any>;
    actionElement?: React.ReactElement<any>;
    isSelected: boolean;
    onClick: () => void;
};

export function RecipientSelectorListItem(props: Props) {
    const {title, subtitle, actionElement, isSelected, onClick} = props;

    return (
        <div className={styles['list-item-container']}>
            <ButtonCard isSelected={isSelected} onClick={onClick}>
                <ActionBox
                    title={<div className={styles.title}>{title}</div>}
                    subtitle={<div className={styles.subtitle}>{subtitle}</div>}
                    actionElement={actionElement}
                    size='small'
                />
            </ButtonCard>
        </div>
    );
}
